import { Box, Divider as MuiDivider, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
  padding: `0 ${theme.spacing(20)} ${theme.spacing(15)}`,
  [theme.breakpoints.down('lg')]: {
    padding: `0 ${theme.spacing(10)} ${theme.spacing(15)}`,
  },
  [theme.breakpoints.down('md')]: {
    padding: `${theme.spacing(10)}`,
  },
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(15)} 0 0`,
  },
}));
export const Title = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(0),
  },
}));

export const TextWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isIndividualElements',
})(({ theme, isIndividualElements }) => ({
  gap: theme.spacing(),
  display: isIndividualElements ? 'block' : 'flex',
  alignItems: 'center',
}));

export const ItemsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isIndividualElements',
})(({ theme, isIndividualElements }) => ({
  borderRadius: '24px',

  backgroundColor: isIndividualElements
    ? 'transparent'
    : theme.palette.color.global.primary,
  padding: isIndividualElements ? 0 : theme.spacing(4),
  alignItems: 'flex-start',
  display: 'flex',
  gap: isIndividualElements ? theme.spacing(4) : 0,
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

export const ItemContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isIndividualElements',
})(({ theme, isIndividualElements }) => ({
  gap: theme.spacing(6),
  display: 'flex',
  flexDirection: 'row!important',
  [theme.breakpoints.down('md')]: {
    flexDirection: isIndividualElements ? 'column!important' : 'row!important',
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    paddingTop: isIndividualElements ? 0 : theme.spacing(3),
    paddingBottom: isIndividualElements ? 0 : theme.spacing(3),
  },
}));

export const CheckIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isIndividualElements',
})(({ theme, isIndividualElements }) => ({
  borderRadius: '16px',
  minWidth: 72,
  alignSelf: 'center',
  minHeight: isIndividualElements ? '100%' : 72,
  backgroundColor: theme.palette.color.fg.tetriary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    minHeight: isIndividualElements ? 56 : 40,
    minWidth: isIndividualElements ? '100%' : 40,
    alignSelf: isIndividualElements ? 'center' : 'flex-start',
  },
}));

export const ULList = styled('ul')(({ theme }) => ({
  paddingLeft: '20px',
  [theme.breakpoints.down('md')]: {
    marginTop: '8px!important',
  },
}));

export const ULListItem = styled('li')(({ theme }) => ({
  marginBottom: 0,
  lineHeight: '27px',
  color: theme.palette.color.fg.tetriary,
  [theme.breakpoints.down('md')]: {
    lineHeight: '20.8px',
  },
}));

export const Text = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasMarginTop',
})(({ theme, hasMarginTop }) => ({
  textAlign: 'start',
  flex: 1,
  marginTop: hasMarginTop ? 10 : 0,
  fontSize: 18,
  lineHeight: '27px',
  color: theme.palette.color.fg.tetriary,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    lineHeight: '20.8px',
  },
}));

export const ItemTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'start',
  fontWeight: 600,
  fontSize: 24,
  lineHeight: '31.2px',
  color: theme.palette.color.fg.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
    marginBottom: theme.spacing(),
    lineHeight: '22px',
  },
}));

export const ItemWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isIndividualElements',
})(({ theme, isIndividualElements }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr',
  borderRadius: isIndividualElements ? '24px' : 0,
  padding: isIndividualElements ? theme.spacing(4) : 0,
  backgroundColor: isIndividualElements
    ? theme.palette.color.global.card
    : 'transparent',
  [theme.breakpoints.down('md')]: {
    padding: isIndividualElements ? theme.spacing(3) : 0,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const Divider = styled(MuiDivider)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  height: 0.5,
  borderBottomWidth: 0,
  width: '100%',
  backgroundColor: theme.palette.color.divider,
  [theme.breakpoints.down('md')]: {
    marginTop: 0,
    marginBottom: 0,
  },
}));
